module.exports = __webpack_public_path__ + "ClientApp/images/content/In-home-euthanasia-lap-of-love.jpg";